import { createAction } from "redux-actions";
import { GET_VALIDATORS } from "../constants";
import { serverFindData } from "../services/validators";

export const findValidators = createAction(GET_VALIDATORS, (service,query) => serverFindData(service, query)())